import { jsx as _jsx } from "react/jsx-runtime";
import { DeletionConfirmationDialog } from 'components/custom';
import { useTranslation } from 'react-i18next';
import { getWeekDayName } from 'utils/date';
import { log, Severity } from 'utils/logger';
const DeleteSlotDialog = ({ course, onConfirm, onClose, }) => {
    const { t } = useTranslation('timetable', {
        keyPrefix: 'steps.lessons.cmp.DeleteSlotDialog',
    });
    return (_jsx(DeletionConfirmationDialog, { open: !!course, onClose: onClose, titleProps: {
            text: t('title'),
        }, cancelButtonProps: {
            onClick: onClose,
        }, confirmButtonProps: {
            children: t('actions.delete'),
            onClick: () => {
                if (course) {
                    onConfirm(course);
                }
                else {
                    log('No course for slot deletion', {
                        dump: course,
                        severity: Severity.ERROR,
                    });
                }
            },
        }, children: t('text', {
            hourInDay: course?.hourInDay,
            name: course?.name,
            weekday: getWeekDayName(course?.weekday ?? 0),
        }) }));
};
export default DeleteSlotDialog;
